export default {
    // CSRF
    BAD_CSRF_TOKEN: "invalid token",

    // Stripe Checkout
    THREE_D_SECURE: "3D secure card transactions are currently not supported. Please try another card.",
    PAYMENT_METHOD_MISSING: "Something went wrong. Please re-enter your payment.",
    DUPLICATE_CUSTOMER_ID: "We do not support multiple credit cards at this time. Please use the card currently associated with your account to continue.",
    UNSUPPORTED_REGION: "We are unable to accept orders from the region associated with your payment method. Please try a different payment source.",

    // Stripe backend
    CUSTOMER_INFORMATION_INVALID: "Country or Postal Code missing from customer information",
    ERROR_FETCHING_CUSTOMER: "Unknown error fetching customer",
    ERROR_FETCHING_CARD: "Unknown error fetching card information",
    ERROR_ADDING_CARD: "Unknown error adding card to stripe",
    ERROR_CREATING_PRE_AUTH_CHARGE: "Unknown error creating pre-authorization charge",
    ERROR_CREATING_PRE_AUTH_REFUND: "Unknown error creating pre-authorization refund",
    ERROR_UPDATING_CUSTOMER_INFO: "Unknown error adding customer information",
    UNSUPPORTED_CARD_TYPE: "Prepaid cards are not supported for this type of transaction. Please use an alternate payment method to complete your order.",

    // BSSO
    BSSO_VALIDATION_ERROR: "Access is denied. Please verify your credentials are correct and try again.",

    // CPREF
    INVALID_MARKETING_OPTION: "Invalid marketing option",

    // apple news
    NO_USERID_ERROR: "No user id associated with this request",

    // student verification
    MISSING_FIRST_NAME: "First name is required",
    MISSING_LAST_NAME: "Last name is required",
    MISSING_SCHOOL: "Please select a participating school",
    INVALID_DATE_OF_BIRTH: "You must provide a valid date of birth",
    UNDER_18: "You must be over 18 to redeem this offer.",
    VALIDATION_FAILED: "We were not able to verify your student status.",
    INVALID_SCHOOL: "You must select a participating school in order to continue.",
    SERVICE_ERROR: "An error occurred attempting to validate your status. Please try again.",
    MISSING_REQUIRED_PARAMETER: "One or more required inputs is missing.",

    // entitlements actions
    ENTITLEMENTS_SHOW_LINKING_ERROR: "Your subscription was not linked. <a href=\"http://www.businessweek.com/service\">Contact us</a> for assistance.",
    ENTITLEMENTS_SHOW_BILLING_HISTORY_LOAD_ERROR: "Your billing history could not be loaded.",
    ENTITLEMENTS_SHOW_BULK_SUBSCRIPTION_ERROR: "",
    ENTITLEMENTS_SHOW_UPGRADE_ERROR: "Unable to apply your upgrade. Please contact customer support.",
    ENTITLEMENTS_SHOW_FILE_DOWNLOAD_ERROR: "An error has occurred while downloading this file.",
    ENTITLEMENTS_SHOW_GET_SUBSCRIPTIONS_ERROR: "Your subscription data failed to load.",

    // loginRegister actions has a custom error message that utilizes appPath change this approach

    // loginRegister actions
    SET_PASSWORD_INVALID_KEY: "Password reset cannot be completed at this time. <a>Click here</a> to re-send link to your email.",

    // account api
    OPERATION_NOT_ALLOWED: "Operation not allowed.",
    INVALID_REGION: "Region not found.",

    // entitlements API
    APPLE_RECEIPT_NOT_FOUND: "Apple receipt not found for user",
    PROVIDER_IS_REQUIRED: "Subscription must include provider",
    CUSTOMER_MISMATCH: "Customer does not match signed in user",

    // facebook client
    UNKNOWN_FACEBOOK_RESPONSE: "Unknown Facebook response code",
    FAILED_TO_FETCH_USER_PROFILE: "Failed to fetch user profile.",
    FAILED_TO_FETCH_BUSINESS_IDS: "Failed to fetch ids for business.",

    // twitter client
    INCORRECT_REPLY_ERROR: "Incorrect Response from Twitter.",
    VALIDATION_ERROR: "Error validating token from Twitter.",
    RATE_LIMIT_EXCEEDED_ERROR: "You have made too many requests to Twitter, please try again in a few minutes.",

    // newsletter API
    INVALID_NEWSLETTER_ID: "Newsletter not found.",
    NEWSLETTER_FETCH_FAILED: "Newsletter data could not be fetched.",
    EMAIL_HASH_MISMATCH: "Email hash does not match",

    // newsletter client
    ERROR_FETCHING_DATA: "Error fetching newsletter data",
    ERROR_UPDATING_SUBSCRIPTION: "Error updating newsletter subscription",
    ERROR_MIGRATING_NEWSLETTERS: "Error migrating newsletter subscriptions to new email",

    // print service client
    FORBIDDEN: "Forbidden",

    // register API
    SUBSCRIPTION_NOT_LINKED: "Your subscription was not linked. Sign in to link it in account settings.",
    SUBSCRIPTION_REGISTRATION_WRONG_PASSWORD: "Subscription registration with wrong password",

    // Bulk Subs has it's own funcitonal format so I'm not consolidating those here
    BULK_SUBSCRIPTION_NO_MATCHING_SUBSCRIPTION: "Could not find associated bulk subscription",
    BULK_SUBSCRIPTION_USER_IS_NOT_ADMIN: "Bulk subscription user is not an admin",
    BULK_SUBSCRIPTION_USER_IS_NOT_IN_SUBSCRIPTION: "Provided user is not in the bulk subscription",

    // BConnect
    USER_PASSWORD_REQUIRED: "Both email and password are required.",
    ACCOUNT_LOCKED: "Account locked. Please check your email to unlock.",
    ACCOUNT_DEACTIVATED: "This account has been deactivated. Please check your email to reactivate.",
    EMAIL_ALREADY_REGISTERED: "This email address is already registered. Sign in, or choose another email.",
    INVALID_EMAIL_ADDRESS: "Email format is invalid.",
    EMAIL_NOT_FOUND: "We cannot find a user with that email.",
    SOCIAL_USER_NOT_FOUND: "Social user not found.",
    ERROR_UPDATING_USER: "Account updates temporarily offline. Please retry.",
    INVALID_NEW_PASSWORD: "New password must be different from the last 3 passwords.",
    WRONG_PASSWORD: "Incorrect Password",
    SOCIAL_USER_ALREADY_LINKED: "This social user is already linked.",
    SOCIAL_USER_NOT_LINKED: "This social user is not linked yet.",
    VALIDATION_KEY_EXPIRED: "The confirmation link has expired. Please retry.",
    VALIDATION_KEY_INVALID: "The confirmation link is invalid. Please retry.",
    UNLOCK_KEY_EXPIRED: "The unlock account link has expired. Please retry.",
    UNLOCK_KEY_INVALID: "The unlock account link is invalid. Please retry.",
    RESET_PASSWORD_KEY_EXPIRED: "The reset password link has expired. Please retry.",
    RESET_PASSWORD_INVALID: "The reset password link is invalid. Please retry.",
    REACTIVATE_KEY_EXPIRED: "The reactivate account link has expired. Please retry.",
    REACTIVATE_KEY_INVALID: "The reactivate account link is invalid. Please retry.",
    EMAIL_OR_PASSWORD_ERROR: "Incorrect password. Please try again.",
    EMAIL_OR_PASSWORD_ERROR_V3: "The email address and password entered do not match any Bloomberg.com accounts. Please try again.",
    USER_KEY_NOT_FOUND: "User key not found",
    REMOVE_USER_KEY_FAILED: "Failed to remove user key",
    SUBSCRIPTION_ALREADY_EXISTS: "A subscription for this product already exists for this account",
    NOT_AUTHORIZED: "Not Authorized",
    EMAIL_NOT_SPECIFIED: "No email provided",
    SUBSCRIPTION_ID_NOT_SPECIFIED: "No subscription id provided",
    INVOICE_ID_NOT_SPECIFIED: "No invoice id provided",
    INVOICE_ID_ALREADY_EXISTS: "Invoice id already exists",
    SUBSCRIPTION_EXPIRED: "The subscription has expired",
    SUBSCRIPTION_NOT_FOUND: "Subscription not found",
    SUBSCRIPTION_FOUND: "You can't deactivate your account because you have an active subscription",
    PRODUCT_ROLE_NOT_FOUND: "Product role not found",
    SAVE_OFFER_FOUND: "You have already accepted a similar offer",
    BULK_SUBSCRIPTION_NAME_NOT_SPECIFIED: "No name provided",
    BULK_SUBSCRIPTION_CUSTOMER_ID_NOT_SPECIFIED: "No customer Id provided",
    BULK_SUBSCRIPTION_ID_NOT_SPECIFIED: "No bulk subscription Id provided",
    BULK_SUBSCRIPTION_SUBSCRIBER_ID_NOT_SPECIFIED: "No subscriber id provided",
    BULK_SUBSCRIPTION_MAX_SUBSCRIBERS_NOT_SPECIFIED: "maxSubscribers not found",
    BULK_SUBSCRIPTION_TOO_MANY_USERS: "Too many users found for this bulk subscription Id",
    BULK_SUBSCRIPTION_ID_NOT_FOUND: "Bulk subscription id not found",
    BULK_SUBSCRIPTION_OR_USER_NOT_FOUND: "Bulk Subscription or the user not found",
    BULK_SUBSCRIPTION_NO_UPDATE_DATA: "No data provided to update bulk subscription",
    BULK_SUBSCRIPTION_MAX_USERS_REACHED: "This subscription already has its maximum allowed number of users.",

    // validation has a different format and is stored elsewhere

    // shared errors
    USER_NOT_FOUND: "User not found.",
    ID_NOT_SPECIFIED: "No id provided",
    OFFER_ID_NOT_SPECIFIED: "No product rate plan id provided",
    EMAIL_IS_REQUIRED: "Email is required",

    CAPTCHA_VALIDATION_FAILED: "Captcha validation failed",

    // generic
    UNKNOWN_SERVER_ERROR: "Unknown server error", // 500
    RATE_LIMITED: "You have sent too many requests. Please try again later.", // 429
    FIELD_REQUIRED: "This field is required",
    FIELDS_IN_ERROR: "One or more required fields have an error.",
    FIELDS_REQUIRED: "One or more fields are required.",
    FIELDS_CONTAIN_INVALID_CHARACTERS: "You may only use valid, english characters.",

    // counter offers
    INTRO_OFFER_NOT_ELIGIBLE: "It looks like you're not eligible to claim this introductory offer.",
    USER_CLAIMED_FREE_TRIAL: "User has already claimed free trial offer",
    USER_CLAIMED_INTRO_OFFER: "User has already claimed intro offer",
    PROMO_NOT_ELIGIBLE: "User is ineligible",

    // referrals
    PRODUCT_RATE_PLAN_ID_IS_REQUIRED: "productRatePlanId is required."
};
